export enum Currency {
  UAH = '₴',
  EUR = '€',
}
